import { computed, EventEmitter, Injectable, signal } from '@angular/core';
import { OptionLink } from '../models/link';

@Injectable()
export class HorizontalMenuService {
  private items = signal<OptionLink[]>([]);

  categoriesHandleMap = computed(() =>
    this._generateItemsHandleMap(this.items())
  );
  rootLevelNodes = computed(() => this.items().map(item => item.handle));

  private _generateItemsHandleMap(items: OptionLink[]) {
    const result = new Map<string, string[]>();
    items.forEach(item => this._processCategory(item, result));
    return result;
  }

  selectedItem = new EventEmitter<OptionLink>();

  setItems(items: OptionLink[]) {
    this.items.set(items);
  }

  getNode(node: string) {
    return this.categoriesHandleMap().get(node);
  }

  getItemByHandle(handle: string, items = this.items()): OptionLink | null {
    for (const item of items) {
      if (item.handle === handle) {
        return item;
      } else if (item.children && item.children.length > 0) {
        const childrenHandle = this.getItemByHandle(handle, item.children);
        if (childrenHandle) return childrenHandle;
      }
    }

    return null;
  }

  isExpandable(node: string): boolean {
    return this.categoriesHandleMap().has(node);
  }

  private _processCategory(item: OptionLink, result: Map<string, string[]>) {
    if (item.children && item.children.length > 0) {
      const childHandles = item.children.map(child => child.handle);
      result.set(item.handle, childHandles);

      item.children.forEach(child => this._processCategory(child, result));
    }
  }

  selectItem(item: OptionLink) {
    this.selectedItem.next(item);
  }
}
